"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
var _constants = _interopRequireDefault(require("./constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let {
  URLs,
  FREE_USER_RECEIPT_SIZE_QUOTA,
  INDEXED_KEYS
} = _constants.default;
class ReceiptHandler extends _ApiHandler.default {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getEntityReceipts", async (entity, entityId) => {
      let url = URLs.ACCOUNT_RECEIPTS + "/" + entity + "/" + entityId;
      let response = await this.standardGetOperation(url);
      return Promise.resolve(response.data);
    });
    _defineProperty(this, "uploadReceipt", (entity, id, formData, config) => {
      return new Promise((resolve, reject) => {
        this.getInstance().post("".concat(URLs.RECEIPTS, "/upload-receipt/").concat(entity, "/").concat(id), formData, config).then(response => {
          if (response.status !== 200) {
            reject(response);
          } else {
            resolve(response);
          }
        }).catch(error => {
          reject(error);
        });
      });
    });
  }
  getReceiptQuota() {
    let retrieveFrom = URLs.USERS + "/me";
    return new Promise((resolve, reject) => {
      this.getInstance().get(retrieveFrom).then(response => {
        let {
          user
        } = response.data;
        let inMB = 0;
        if (user && user.receipts_size) {
          inMB = user.receipts_size / 1024 / 1024;
        }
        resolve(inMB);
      }).catch(err => this.handleError(err, "Error while fetching user quota."));
    });
  }
  getReceiptQuotaBal() {
    let quota = FREE_USER_RECEIPT_SIZE_QUOTA / 1024;
    return new Promise((resolve, reject) => {
      this.getReceiptQuota().then(used => {
        resolve(quota - used);
      });
    });
  }
  getEntityReceiptsCached(entity, entityId) {
    let unset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let key = INDEXED_KEYS.ENTITY_RECEIPTS + "_" + entity + "_" + entityId;
    console.debug("key: [".concat(key, "] clear: [").concat(unset, "]"));
    return this.cachedResponse(unset, key, this.getEntityReceipts, [entity, entityId]);
  }
  deleteReceipt(id) {
    return new Promise((resolve, reject) => {
      let retrieveFrom = "".concat(URLs.ACCOUNT_RECEIPTS, "/").concat(id);
      this.getInstance().delete(retrieveFrom).then(() => {
        //this.showSuccess('Receipt deleted successfully');
        resolve('');
      }).catch(this.handleError);
    });
  }
  getReceiptSignedUrl(id) {
    return new Promise((resolve, reject) => {
      this.getInstance().get(URLs.RECEIPTS + '/' + id).then(response => {
        if (response.status === 200) {
          resolve(response.data.url);
        } else {
          //this.showWarn(response.data.error);
        }
      }).catch(this.handleError);
    });
  }
  deleteEntityReceipts(entity, entityId) {
    let retrieveFrom = URLs.ACCOUNT_RECEIPTS + "/" + entity + "/" + entityId;
    this.getInstance().get(retrieveFrom).then(() => {
      //this.showSuccess('Receipts deleted successfully.');
    }).catch(this.handleError);
  }
  updateReceiptDetails(id, data) {
    this.getInstance().put(URLs.RECEIPTS + '/' + id, data).then(response => {
      //this.showSuccess('Receipt updated successfully.')
    }).catch(this.handleError);
  }
}
exports.default = ReceiptHandler;